import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  label?: string
  name?: string
}

export const FormNomenclatureDefaultItem = ({
  label = 'nomenclature.name',
  name = 'name'
}: Props) => {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={name}
      label={t(label)}
      rules={[
        {
          required: true
        }
      ]}
    >
      <Input placeholder={t(label)} />
    </Form.Item>
  )
}
